exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  border: thin solid silver;\n  margin: 0.6ex;\n  padding: 0.6ex;\n}\n\ndiv.main div {\n  margin-top: 0.5ex;\n}\n\ndiv.doi {\n  font-style: italic;\n  font-size: small;\n}\n\ndiv.isbn, div.issn {\n  font-size: small;\n}\n\ndiv.authors {\n  font-size: small;\n  font-style: italic;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/crossref-record-box/crossref-record-box.component.css
// module id = 384
// module chunks = 0